import React, { useState, useRef, useEffect } from 'react';
import { func, string } from 'prop-types';
import { translate } from 'react-i18next';
import { fromEvent } from 'rxjs';
import { map, first, filter } from 'rxjs/operators';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  AppStoreBlackIcon,
  GooglePlayStoreIcon,
  ChevronRightIcon,
} from '@snapask/common-components';

import Link from '@dragonfruit/components/Link';

import {
  WEB_SUBSCRIPTION_GROUPS,
  PROMOTION,
} from '@dragonfruit/constants/premiumPage';
import { HOME_DOWNLOAD_CLICK } from '@dragonfruit/constants/gtmEvents';
import { ANDROID, IOS } from '@dragonfruit/constants/appDownloadType';

import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';
import { getRegion } from '@dragonfruit/redux/locale';

import homeIcon from '../../images/ic_home_active_24.svg';
import qzcontIcon from '../../images/ic_qzcont_active_24.svg';
import sessionIcon from '../../images/ic_session_active_24.svg';
import classroomIcon from '../../images/ic_classroom_active_24.svg';
import sessionImage from './images/promotion_image1.png';
import qzcontImage from './images/promotion_image2.png';
import classroomImage from './images/promotion_image3.png';
import homeImage from './images/promotion_image4.png';

import styles from './PromotionBlock.scss';
const cx = require('classnames/bind').bind(styles);

function PromotionBlock({ t, sendGtmEvent, userRegion }) {
  const [firstShow, setFirstShow] = useState(false);
  const elm = useRef(null);

  const onIosDownloadClick = () => {
    sendGtmEvent({
      eventName: HOME_DOWNLOAD_CLICK,
      data: {
        region: userRegion,
        type: IOS,
      },
    });
  };

  const onAndroidDownloadClick = () => {
    sendGtmEvent({
      eventName: HOME_DOWNLOAD_CLICK,
      data: {
        region: userRegion,
        type: ANDROID,
      },
    });
  };

  useEffect(() => {
    // animation only run when scrolling over the title
    const subscribe$ = fromEvent(window, 'scroll')
      .pipe(
        map(() => elm.current),
        map(
          ({ offsetTop, offsetHeight, parentNode }) =>
            offsetTop + offsetHeight + parentNode.offsetTop
        ),
        map(elementBottom => ({
          scrollY: window.scrollY + window.innerHeight,
          elementBottom,
        })),
        filter(({ scrollY, elementBottom }) => scrollY > elementBottom),
        first()
      )
      .subscribe(() => setFirstShow(true));

    return () => subscribe$.unsubscribe();
  }, []);

  return (
    <section className={cx(styles.root, { firstShow })} id={PROMOTION}>
      <h1 className={styles.title} ref={elm}>
        {t('premium.promotion.title')}
      </h1>
      <div className={styles.links}>
        <Link
          to={t('common:common.ios_download_link')}
          newTab
          className={styles.link}
          onClick={onIosDownloadClick}
        >
          <AppStoreBlackIcon width={142} height={46} />
        </Link>
        <Link
          to={t('common:common.android_download_link')}
          newTab
          className={styles.link}
          onClick={onAndroidDownloadClick}
        >
          <GooglePlayStoreIcon width={149} height={46} />
        </Link>

        <Link className={styles.ctaLink} to={`#${WEB_SUBSCRIPTION_GROUPS}`}>
          <p>{t('premium.promotion.planCTA')}</p>
          <ChevronRightIcon
            className={styles.arrowIcon}
            width={26}
            height={26}
          />
        </Link>
      </div>
      <div className={styles.sessionBlock}>
        <img src={sessionImage} className={styles.sessionImage} />
        <img src={sessionIcon} className={styles.sessionIcon} />
      </div>
      <div className={styles.qzcontBlock}>
        <img src={qzcontIcon} className={styles.qzcontIcon} />
        <img src={qzcontImage} className={styles.qzcontImage} />
      </div>
      <div className={styles.classroomBlock}>
        <img src={classroomIcon} className={styles.classroomIcon} />
        <img src={classroomImage} className={styles.classroomImage} />
      </div>
      <div className={styles.homeBlock}>
        <img src={homeImage} className={styles.homeImage} />
        <img src={homeIcon} className={styles.homeIcon} />
      </div>
    </section>
  );
}

PromotionBlock.propTypes = {
  sendGtmEvent: func.isRequired,
  t: func.isRequired,
  userRegion: string.isRequired,
};

export default compose(
  translate(['premium']),
  connect(state => ({ userRegion: getRegion(state) }), { sendGtmEvent })
)(PromotionBlock);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/PromotionBlock/PromotionBlock.jsx